/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import "../css/index.css";
import L from "leaflet";
import {
  LayersControl,
  MapContainer,
  Marker,
  Popup,
  TileLayer,
  useMap
} from "react-leaflet";
import { logInWithEmailAndPasswordAndGetData } from "../config/firebaseConfig";
import MarkerClusterGroup from "react-leaflet-markercluster";
import "react-leaflet-markercluster/dist/styles.min.css";
import "./custom.css";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";

import Conifer from "../components/icons/conifer.png";
import Broadleaf from "../components/icons/broadleaf.png";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { FacebookIcon, FacebookShareButton, TwitterIcon, TwitterShareButton } from "react-share";

ChartJS.register(ArcElement, Tooltip, Legend);

const options = {
  weekday: "long",
  year: "numeric",
  month: "long",
  day: "numeric",
  hour: "numeric",
  minute: "2-digit",
  hour12: true
};

const layers = [
  {
    name: "Normal",
    attribution:
      '&copy; <a href="http://openstreetmap.org">OpenStreetMap</a>OpenStreetMap</a> contributors',
    url: "http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
  },
  {
    name: "Aerial",
    attribution:
      "Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community",
    url: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
  },
  {
    name: "Dark",
    attribution:
      '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
    url: "https://{s}.basemaps.cartocdn.com/rastertiles/dark_all/{z}/{x}/{y}.png"
  },
  {
    name: "Toner",
    attribution:
      'Map tiles by Stamen Design, under CC BY 3.0. Data by OpenStreetMap, under CC BY SA.',
    url: "http://stamen-tiles-{s}.a.ssl.fastly.net/toner-lite/{z}/{x}/{y}.png"
  }
];

const generateTreeCount = data => {
  const sortedData = data.sort((a, b) => {
    if (a.treeType === "broadleaf") {
      return -1;
    }
    if (b.treeType === "broadleaf") {
      return 1;
    }
    return 0;
  });

  const treeCountMap = new Map();

  sortedData.forEach(item => {
    const { treeType, speciesNameCommon } = item;
    const key = `${treeType}-${speciesNameCommon}`;

    if (treeCountMap.has(key)) {
      treeCountMap.set(key, treeCountMap.get(key) + 1);
    } else {
      treeCountMap.set(key, 1);
    }
  });

  const labels = Array.from(treeCountMap.keys());
  const counts = Array.from(treeCountMap.values());

  return { labels, counts };
};

export default function Main() {
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedSpeciesNameCommon, setSelectedSpeciesNameCommon] = useState(null);
  const [species, setSpecies] = useState([]);
  const [usernames, setUsernames] = useState([]);
  const [center, setCenter] = useState([39.8282, -98.5795]);
  const [trees, setTrees] = useState([]);
  const [filteredPoints, setFilteredPoints] = useState([]);

  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const param = searchParams.get("user");
  const history = useHistory();

  useEffect(() => {
    if (param) {
      setSelectedUser(param);
    } else {
      setSelectedUser('');
    }
  }, [param, search]);


  useEffect(() => {
    const fetchTrees = async () => {
      try {
        let email = "test@email.com";
        let password = "test123";
        logInWithEmailAndPasswordAndGetData(email, password)
          .then(data => {
            let correctData = [];
            data.map(object => {
              if (object.userId && object.isValidated !== "SPAM") {
                correctData.push(object);
              }
              return null;
            });
            setTrees(correctData);
            setFilteredPoints(param ? correctData.filter(tree => tree.username === param) : correctData);
          })
          .catch(error => {
            // Handle any error that occurs during login or data fetching
            console.error('fetchTrees error:', error);
          });
      } catch (error) {
        console.log("Error retrieving trees:", error);
      }
    };

    fetchTrees();
  }, [param]);

  function fuzzyLatLng(lat, lng, miles) {
    let milesPerDegreeLatitude = 69.09,
      milesPerDegreeLongitude =
        milesPerDegreeLatitude * Math.cos((lat * Math.PI) / 180),
      degreesOfLatitudeRandomness = miles / milesPerDegreeLatitude,
      degreesOfLongitudeRandomness = miles / milesPerDegreeLongitude,
      coordinates = {
        latitude:
          lat -
          degreesOfLatitudeRandomness +
          degreesOfLatitudeRandomness * (2 * Math.random()),
        longitude:
          lng -
          degreesOfLongitudeRandomness +
          degreesOfLongitudeRandomness * (2 * Math.random())
      };
    return coordinates;
  }

  const setUniqueUsernamesAndSpecies = (data) => {
    const uniqueUsernames = [
      ...new Set(data.map(point => point.username))
    ].sort();
    setUsernames(uniqueUsernames);

    const uniqueSpecies = [
      ...new Set(data.map(point => point.speciesNameCommon))
    ].sort();
    setSpecies(uniqueSpecies);
  }

  useEffect(() => {
    setUniqueUsernamesAndSpecies(trees);
  }, [trees]);

  const handleUserChange = event => {
    setSelectedUser(event.target.value);
    const filteredDataBySpecies = selectedSpeciesNameCommon ? trees.filter(point => point.speciesNameCommon === selectedSpeciesNameCommon) : trees;
    const filteredData = event.target.value
      ? filteredDataBySpecies.filter(point => point.username === event.target.value)
      : filteredDataBySpecies;
    setUniqueUsernamesAndSpecies(filteredData);
    if (filteredPoints.length > 0) {
      const { coords } = filteredPoints[0];
      let tempcoordinates = fuzzyLatLng(coords?._lat, coords?._long, 0.5);
      setCenter([
        tempcoordinates.latitude || 39.8282,
        tempcoordinates.longitude || -98.5795
      ]);
    }
    setFilteredPoints(filteredData);
    event.target.value ? history.push(`/?user=${event.target.value}`) : history.push(`/`);
  };

  const handleSpeciesNameCommonChange = event => {
    setSelectedSpeciesNameCommon(event.target.value);
    const filteredDataByUsername = selectedUser
      ? trees.filter(point => point.username === selectedUser)
      : trees;
    const filteredData = event.target.value
      ? filteredDataByUsername.filter(point => point.speciesNameCommon === event.target.value)
      : filteredDataByUsername;
    setUniqueUsernamesAndSpecies(filteredData);
    if (filteredPoints.length > 0) {
      const { coords } = filteredPoints[0];
      let tempcoordinates = fuzzyLatLng(coords?._lat, coords?._long, 0.5);
      setCenter([
        tempcoordinates.latitude || 39.8282,
        tempcoordinates.longitude || -98.5795
      ]);
    }
    setFilteredPoints(filteredData);
  };

  const DynamicCenterMap = () => {
    const map = useMap();
    map.setView(center, map.getZoom());
    return null;
  };

  let coniferVal = filteredPoints?.filter(val => val.treeType === "conifer");
  let broadleafVal = filteredPoints?.filter(
    val => val.treeType === "broadleaf"
  );
  const { labels, counts } = generateTreeCount(filteredPoints);

  const pieOptions = {
    plugins: {
      legend: {
        display: false
      }
    },
    onClick: function (evt, element) {
      if (element.length > 0) {
        const label = labels[element[0].index];
        handleSpeciesNameCommonChange({
          target: { value: label.split("-")[1] }
        });
      }
    },
    elements: {
      arc: {
        borderWidth: 0
      }
    }
  };

  const backgroundColors = labels.map(label => {
    const treeType = label.split("-")[0];
    return treeType === "broadleaf" ? "#0A8A0A" : "#004400";
  });

  const data = {
    maintainAspectRatio: false,
    responsive: false,
    labels: labels.map(label => label.split("-")[1]),
    datasets: [
      {
        data: counts,
        backgroundColor: backgroundColors,
        hoverBackgroundColor: backgroundColors,
        borderWidth: 0.1,
        borderColor: "#ECECEC"
      }
    ]
  };

  const createClusterCustomIcon = function (cluster) {
    const childCount = cluster.getChildCount();
    let c = ' marker-cluster-';
    let circleSize = 0;
    if (childCount < 10) {
      c += 'small';
      circleSize = 60;
    } else if (childCount < 100) {
      c += 'medium';
      circleSize = 90;
    } else {
      c += 'large';
      circleSize = 110;
    }
    return L.divIcon({
      html: '<div><span>' + childCount + '</span></div>',
      className: 'marker-cluster' + c,
      iconSize: L.point(circleSize, circleSize, true)
    });
  }

  return (
    <div className='container-fluid pad' id='pad'>
      <div className='row'>
        <div className='col-md-5 padrightblock' id='padrightblock'>
          <div
            className='card'
            style={{ marginBottom: "5px", textAlign: "center" }}
          >
            <div className='firstsect' id=''>
              <b>
                <span id='projecthead' className='projecthead'>
                  Total count of trees
                </span>
              </b>{" "}
              <br />
              <b className='sbheadfont' id='sbheadfont'>
                {filteredPoints.length}
              </b>
            </div>
          </div>
          {/* <div className='row no-gutters'>
            <div className='col-md-6' style={{ paddingRight: "2px" }}>
              <div
                className='card'
                id=''
                style={{
                  marginBottom: "5px",
                  textAlign: "center"
                }}
              >
                <div className='card-body pad011' id='pad011'>
                  <b>
                    <span id='projecthead1' className='projecthead1'>
                      Number of Conifers
                    </span>
                  </b>{" "}
                  <br />
                  <div id='acresBound' className='acresBound'>
                    <b id='sbheadfont1' className='sbheadfont1'>
                      {coniferVal.length ? coniferVal.length : 0}
                    </b>
                  </div>
                </div>
              </div>
            </div>
            <div className='col-md-6' style={{ paddingLeft: "2px" }}>
              <div
                className='card'
                id=''
                style={{
                  marginBottom: "5px",
                  textAlign: "center"
                }}
              >
                <div className='card-body pad011' id='pad011'>
                  <b>
                    <span id='projecthead1' className='projecthead1'>
                      Number of Broadleaf
                    </span>
                  </b>{" "}
                  <br />
                  <div id='acresBound' className='acresBound'>
                    <b id='sbheadfont2' className='sbheadfont2'>
                      {broadleafVal.length ? broadleafVal.length : 0}
                    </b>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
          <div className='card textcenter' id='textcenter'>
            <div className='card-body paddlow' id='paddlow'>
              <div id='fonthead1' className='fonthead1'>
                <b id='smallfont' className='smallfont'>
                  Tree Species
                </b>{" "}
                <br />
                <div className='smallfont'>
                  <label htmlFor='species' className='mt-1 mb-2'>
                    <b>Filter by Species</b>
                  </label>
                  <select
                    id='species'
                    value={selectedSpeciesNameCommon || ""}
                    onChange={handleSpeciesNameCommonChange}
                    className='mb-2'
                  >
                    <option value=''>Show all Species</option>
                    {species.map((point, index) => (
                      <option key={index} value={point}>
                        {point}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div id='chartWrapper' className='chartWrapper'>
                <div id='chartLegend' className='chartLegend mb-1'>
                  <img
                    src={Conifer}
                    alt='conifer'
                    className='treeIcons'
                    style={{
                      width: "25px",
                      height: "25px",
                      margin: "0px 10px"
                    }}
                  />
                  <p> Conifers: {coniferVal?.length || 0}</p>
                  <img
                    src={Broadleaf}
                    alt='broadleaf'
                    className='treeIcons'
                    style={{
                      width: "25px",
                      height: "25px",
                      margin: "0px 10px"
                    }}
                  />
                  <p> Broadleaf: {broadleafVal?.length || 0}</p>
                </div>
                <div
                  id='chartContainer'
                  className='chartContainer'
                  style={styles.pieContainer}
                >
                  <Doughnut data={data} options={pieOptions} />
                </div>
              </div>
            </div>
          </div>
          <div className='card'>
            <div
              className='p-1'
              style={{ display: "flex", backgroundColor: "white" }}
            >
              {/* SHARE */}
              {/* <a href='#' id='fblink' className='fblink' target='_blank'>
                <img
                  src='https://treemama.org/wp-content/themes/nimva-child/dashboard/public/icons/fb.png'
                  alt='facebook'
                  style={{ marginRight: "10px" }}
                />{" "}
                &nbsp;
              </a> */}
              <FacebookShareButton url={window.location.href} quote="Tree Dashboard" style={{ marginRight: "10px" }}>
                <FacebookIcon size={32} round={true} />
              </FacebookShareButton>
              {/* <a href='#' id='tweetlink' className='tweetlink' target='_blank'>
                <img
                  src='https://treemama.org/wp-content/themes/nimva-child/dashboard/public/icons/twitter.png'
                  alt='twitter'
                  style={{ marginRight: "10px" }}
                />{" "}
                &nbsp;
              </a> */}
              <TwitterShareButton url={window.location.href} title="Tree Dashboard" style={{ marginRight: "10px" }}>
                <TwitterIcon size={32} round={true} />
              </TwitterShareButton>
              <a
                href='https://treemama.org/tree-dashboard/'
                id='shareLink'
                className='shareLink'
              >
                <img
                  src='https://treemama.org/wp-content/themes/nimva-child/dashboard/public/icons/link.png'
                  alt='link'
                  style={{ marginRight: "10px", marginTop: "4px" }}
                />
              </a>
              <br />
              {/* Add a line break here */}
              <small className='text-inline' style={{ alignSelf: 'center' }}>
                <span style={{ fontWeight: "bold" }}>Note: </span>
                The exact GPS location of trees are recorded, but not displayed, on this dashboard for privacy reasons.
              </small>
            </div>
          </div>
        </div>
        <div className='col-md-7 padleftblock' id='padleftblock'>
          <div className='map-wrapper'>
            <div className='map-container'>
              <MapContainer
                className='markercluster-map'
                center={center}
                zoom={4}
                scrollWheelZoom={true}
              >
                <LayersControl position='topright'>
                  {layers.map((layer, index) => {
                    return (
                      <LayersControl.BaseLayer
                        key={index}
                        checked={index === 0 ? true : false}
                        name={layer.name}
                      >
                        <TileLayer
                          attribution={layer.attribution}
                          url={layer.url}
                        />
                        <DynamicCenterMap />
                      </LayersControl.BaseLayer>
                    );
                  })}
                </LayersControl>

                <MarkerClusterGroup
                  key={selectedUser || "all"}
                  spiderfyOnMaxZoom={false}
                  iconCreateFunction={createClusterCustomIcon}
                >
                  {filteredPoints?.map(
                    (
                      {
                        coords,
                        photo,
                        speciesNameCommon,
                        speciesNameScientific,
                        treeType,
                        dbh,
                        username,
                        notes,
                        landUseCategory,
                        locationType,
                        isValidated,
                        created_at
                      },
                      index
                    ) => {
                      const date = new Date(
                        created_at?.seconds * 1000
                      ).toLocaleString("en-US", options);
                      let tempcoordinates = fuzzyLatLng(
                        coords?._lat,
                        coords?._long,
                        0.5
                      );
                      return (
                        <Marker
                          key={index}
                          position={[
                            tempcoordinates.latitude || 39.8282,
                            tempcoordinates.longitude || -98.5795
                          ]}
                          icon={L.icon({
                            iconUrl: treeType === "conifer" ? Conifer : Broadleaf,
                            // "https://res.cloudinary.com/getweys/image/upload/v1683765048/broadleaf_uhbtpd.png",
                            iconSize: [32, 32]
                          })}
                        >
                          <Popup>
                            <div className='leaflet-popup-custom'>
                              <img src={photo?.url} alt='tree' />
                              <div>
                                <p>
                                  <b>Species Name (Common):</b>{" "}
                                  {speciesNameCommon}
                                </p>
                                <p>
                                  <b>Species Name (Scientific):</b>{" "}
                                  {speciesNameScientific}
                                </p>
                                <p>
                                  <b>Tree Type</b>: {treeType}
                                </p>
                                <p>
                                  <b>DBH:</b> {dbh}
                                </p>
                                <p>
                                  <b>Username:</b> {username}
                                </p>
                                <p>
                                  <b>Is Validated:</b> {isValidated}
                                </p>
                                <p>
                                  <b>Land Use Category:</b> {landUseCategory}
                                </p>
                                <p>
                                  <b>Location Type:</b> {locationType}
                                </p>
                                <p>
                                  <b>Created at:</b> {date}
                                </p>
                                <p>
                                  <b>Notes:</b> {notes}
                                </p>
                              </div>
                            </div>
                          </Popup>
                        </Marker>
                      );
                    }
                  )}
                </MarkerClusterGroup>
              </MapContainer>
            </div>

            <div className='dropdown-container-left'>
              <label htmlFor='treeType'>
                <b>Filter by Username</b>
              </label>
              <select
                id='treeType'
                value={selectedUser || ""}
                onChange={handleUserChange}
              >
                <option value=''>Show all Users</option>
                {usernames.map((point, index) => (
                  <option key={index} value={point}>
                    {point}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
      </div>
    </div >
  );
}

const styles = {
  pieContainer: {
    width: "65%",
    height: "auto"
  },
  relative: {
    position: "relative"
  }
};
